import * as React from 'react';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { PromptDialog } from 'src/components/PromptDialog';
import { validateProjectModelName } from 'src/containers/ProjectModelDialog/hooks/validators';
import { projectModelSelector } from 'src/selectors/projectModel';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const RenameProjectModelDialog: React.VFC = () => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();

  const { isOpen, modelId } = useReduxSelector(
    (state) => state.ui.renameProjectModelDialog
  );

  const model = useReduxSelector(
    projectModelSelector(projectId, modelId || '')
  );

  const handleClose = React.useCallback(() => {
    dispatch(
      uiSlice.actions.toggledRenameProjectModelDialog({
        isOpen: false,
      })
    );
  }, [dispatch]);

  const handleSubmit = React.useCallback(
    (modelName: string) => {
      if (!modelId) {
        return;
      }

      dispatch(
        projectsActionCreators.updatedProjectModel(projectId, modelId, {
          name: modelName,
        })
      );

      handleClose();
    },
    [dispatch, handleClose, modelId, projectId]
  );

  return (
    <PromptDialog
      getErrorTextForValue={validateProjectModelName}
      handleCancel={handleClose}
      handleSubmit={handleSubmit}
      initialValue={model?.name || ''}
      isOpen={isOpen}
      placeholder={model?.name || ''}
      submitButtonText={
        copy.components.projectModelDialog.renameModelDialog.submit
      }
      title={copy.components.projectModelDialog.renameModelDialog.title}
    />
  );
};
